import * as THREE from "three";

export function initCamera(currentDom: HTMLElement) {
  /**
   * 摄像机
   */
  const camera = new THREE.PerspectiveCamera(
    30, //45
    currentDom.clientWidth / currentDom.clientHeight,
    0.1,
    1000
  );
  /** 摆放相机的位置；Z 轴朝上，与地图挤出方向一致 */
  camera.up.set(0, 0, 1);
  camera.position.set(-10, -90, 130);

  /**
   * 设置CameraHelper
   */
  const cameraHelper = new THREE.CameraHelper(camera);

  return { camera, cameraHelper };
}
